import React from "react";
import AddEmployeeForm from "./AddEmployeeForm";
import "./CreateEmployeePage.css";

function CreateEmployeePage() {
  return (
    <div className="create-employee-page">
      <h1>Créer un nouveau salarié</h1>
      <AddEmployeeForm />
    </div>
  );
}

export default CreateEmployeePage;
